'use client'

import styled from 'styled-components'

export const ContentfulPageBackground = styled.div`
  background-color: ${o => o.theme.color.fill.background};
  color: ${o => o.theme.color.text.primary.on.background};
`
